import React from 'react';
import { ShopIcon } from '../../assets/icons';
import  zonesImg  from '../../assets/img/zones.png';
import CartListZone from '../../components/Zones/CardList/CartListZone';
import { Translate } from '../../language';
import Button from '../../utils/components/Button/Button';
import InputSearch from '../../utils/components/InputSearch/InputSearch';
import style from "./Zones.module.css";
const Zones = ({ zones,myZones,searchAction }) => {
    return (
        <div>
         
            <div className='showCase-title-container'>
                <div className='showCase-icon-container'>
                <img height={25} src={zonesImg} alt="" />
                </div>
                <div className="showCase-title">{Translate('zones', 'es')}</div>
            </div>
            <div className={style.zones_input_search_container}>
                <InputSearch searchData={(value) => searchAction(value)} classNameContent={style.zones_input_search} isDrowMenu ={false} />
            </div>
            <div className={style.zones_container}>
                <div className={style.zones_explore_grid_container}>
                    <Button text='Mis Zonas' theme='white'/>
                    <div className={style.zones_explore_grid}>

                        {
                            myZones.map(zone => (
                                <CartListZone picture={zone.picture && zone.picture.url && zone.picture.url.medium}
                                    _id={zone._id}
                                    textOne={zone.name}
                                    textTwo={zone.categoryId.name}
                                />
                            ))
                        }
                    </div>
                </div>

                <div className={style.zones_explore_grid_container}>
                    <Button text='Explora'  theme='white'/>
                    <div className={style.zones_explore_grid}>

                        {
                            zones.map(zone => (
                                <CartListZone picture={zone.picture && zone.picture.url && zone.picture.url.medium}
                                    _id={zone._id}
                                    textOne={zone.name}
                                    textTwo={zone.categoryId.name}
                                />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Zones;
